module.exports = __webpack_public_path__ + "static/media/python_logo.fbef321e.svg";